module.exports = __webpack_public_path__ + "img/mirror00.e9221ae8.jpg";